<template>
  <div class="container-fluid">
    <div class="row">
        <div class="col-12">
            <div class="card" v-if="po">
                <div class="card-header pb-0">
                    <div class="justify-content-between d-flex">
                        <button 
                            type="button"
                            @click="download"
                            :class="'btn btn-xs btn-outline-primary text-xs font-weight-normal m-0 ' + (loading ? 'disabled' : '')">
                            <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true" v-if="loading"></span>
                            <i class="fa fa-download" v-if="!loading"></i> Download
                        </button>
                        <argon-badge variant="gradient" color="primary" class="text-xxs align-self-center" v-if="po && po.state">{{ po.state }}</argon-badge>
                    </div>
                    <hr/>
                </div>
                <div class="card-body min-vh-50 pt-0">
                    <h5>#{{ po.name }}</h5>
                    <div class="row">
                        <div class="col-sm-6">
                            <table class="text-sm" width="100%">
                                <tbody>
                                    <tr>
                                        <td class="text-secondary" width="30%">Vendor</td>
                                        <td class="fw-bold">{{ po.partner_name }}</td>
                                    </tr>
                                    <tr>
                                        <td class="text-secondary align-top">Type of Procurement</td>
                                        <td class="fw-bold align-top">{{ po.type_of_procurement }}</td>
                                    </tr>
                                    <tr>
                                        <td class="text-secondary">Currency</td>
                                        <td class="fw-bold">{{ po.currency_name }}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <div class="col-sm-6">
                            <table class="text-sm" width="100%">
                                <tbody>
                                    <tr>
                                        <td class="text-secondary" width="30%">Order Date</td>
                                        <td class="fw-bold">{{ po.date_order }}</td>
                                    </tr>   
                                    <tr>
                                        <td class="text-secondary">Expected Arrival</td>
                                        <td class="fw-bold">{{ po.date_planned }}</td>
                                    </tr>
                                    <tr>
                                        <td class="text-secondary">Ready to Billed</td>
                                        <td class="fw-bold">
                                            <input type="checkbox" value="" id="flexCheckChecked" :checked="po.ready_to_billed ? true : false " disabled>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <div class="table-responsive p-0 mt-3">
                        <table class="table align-items-center mb-0">
                            <thead>
                                <tr class="bg-light">
                                    <th class="text-uppercase text-secondary text-xxs fw-bolder opacity-7 ps-2">#</th>
                                    <th class="text-uppercase text-secondary text-xxs fw-bolder opacity-7 ps-2">Product</th>
                                    <th class="text-uppercase text-secondary text-xxs fw-bolder opacity-7 ps-2">Description</th>
                                    <th class="text-uppercase text-secondary text-xxs fw-bolder opacity-7 ps-2">Quantity</th>
                                    <th class="text-uppercase text-secondary text-xxs fw-bolder opacity-7 ps-2">Quantity Received</th>
                                    <th class="text-uppercase text-secondary text-xxs fw-bolder opacity-7 ps-2">Quantity Invoiced</th>
                                    <th class="text-uppercase text-secondary text-xxs fw-bolder opacity-7 ps-2">Unit Price (Exclude VAT)</th>
                                    <th class="text-uppercase text-secondary text-xxs fw-bolder opacity-7 ps-2" v-if="po.vendor_tax_identity_pkp">Taxes</th>
                                    <th class="text-uppercase text-secondary text-xxs fw-bolder opacity-7 ps-2">Subtotal</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="line,i in po_lines" :key="line.purchase_order_line_id">
                                    <td class="text-xs mb-0 ps-2">{{ i+1 }}</td>
                                    <td>
                                        <p class="text-xs mb-0">{{ line.product_name }}</p>
                                    </td>
                                    <td>
                                        <p class="text-xs mb-0">{{ line.name }}</p>
                                    </td>
                                    <td>
                                        <p class="text-xs text-end mb-0">{{ line.product_qty }}</p>
                                    </td>
                                    <td>
                                        <p class="text-xs text-end mb-0">{{ line.qty_received }}</p>
                                    </td>
                                    <td>
                                        <p class="text-xs text-end mb-0">{{ line.qty_invoiced }}</p>
                                    </td>
                                    <td>
                                        <p class="text-xs text-end mb-0">{{ line.price_unit }}</p>
                                    </td>
                                    <td v-if="po.vendor_tax_identity_pkp">
                                        <div class="d-grid gap-2 d-flex">
                                        <argon-badge color="info" class="text-xxs align-self-center" v-for="tax,i in line.account_tax_ids" :key="i">{{ tax }}</argon-badge>
                                        </div>
                                    </td>
                                    <td>
                                        <p class="text-xs text-end mb-0 px-2">{{ line.price_subtotal }}</p>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div class="row mt-3">
                        <div class="col-md offset-md-8 px-4">
                            <table class="text-sm fw-bold" width="100%">
                                <tbody>
                                    <template v-if="po.vendor_tax_identity_pkp">
                                        <tr>
                                            <td class="" width="50%">Untaxed Amount</td>
                                            <td class="text-end">{{ po.amount_untaxed }}</td>
                                        </tr>   
                                        <tr>
                                            <td class="">Amount Tax</td>
                                            <td class="text-end">{{ po.amount_tax }}</td>
                                        </tr>
                                    </template>
                                    <tr>
                                        <td class="border-top">Amount Total</td>
                                        <td class="border-top fw-bold text-end">{{ po.amount_total }}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
  </div>
</template>

<script>
import ArgonBadge from '../components/ArgonBadge.vue'
const endpoint = require(("../router/endpoint"))

export default {
    name: 'po-detail',
    data () {
        return {
            po: null,
            po_lines: [],
            loading: false
        }
    },
    components: {
        ArgonBadge
    },
    methods: {
        getPODetail() {
            this.axios
                .post(
                endpoint.PO_LIST,
                {
                    purchase_id: parseInt(this.$route.params.id.split('_')[0]),
                    partner_id: parseInt(localStorage.getItem('partner_id')),
                    limit: 1,
                    offset: 0
                },
                {
                    headers: {
                    Authorization: `Bearer ${localStorage.getItem("token")}`
                    }
                }
                )
                .then((response) => {
                if (response.data.msg_status === "0002"){
                    this.$notify({
                        type: 'warn',
                        title: 'Expired',
                        text: 'Session expired, please sign in again.',
                    });
                    this.$router.replace('/signin')
                    return false
                } else if (response.data.response_code === "0000") {
                    this.po = response.data.data[0];
                } else {
                    this.$notify({
                        type: 'warn',
                        title: 'Warning',
                        text: response.data.message,
                    });
                    this.loading = false;
                }
                })
                .catch((e) => {
                this.loading = false;
                this.$notify({
                    type: 'error',
                    title: 'Something went wrong!',
                    text: e.response.data.message || e,
                    });
                });
        },
        getPOLines() {
            this.axios
                .post(
                endpoint.PO_LINES,
                {
                    purchase_id: parseInt(this.$route.params.id.split('_')[0]),
                    partner_id: parseInt(localStorage.getItem('partner_id')),
                    limit: 1000,
                    offset: 0
                },
                {
                    headers: {
                    Authorization: `Bearer ${localStorage.getItem("token")}`
                    }
                }
                )
                .then((response) => {
                if (response.data.msg_status === "0002"){
                    this.$notify({
                        type: 'warn',
                        title: 'Expired',
                        text: 'Session expired, please sign in again.',
                    });
                    this.$router.replace('/signin')
                    return false
                } else if (response.data.response_code === "0000") {
                    this.po_lines = response.data.data;
                } else {
                    this.$notify({
                        type: 'warn',
                        title: 'Warning',
                        text: response.data.message,
                    });
                    this.loading = false;
                }
                })
                .catch((e) => {
                this.loading = false;
                this.$notify({
                    type: 'error',
                    title: 'Something went wrong!',
                    text: e.response.data.message || e,
                    });
                });
        },
        download () {
            this.loading = true
            this.axios
                .post(
                endpoint.DOWNLOAD,
                {
                    partner_id: parseInt(localStorage.getItem('partner_id')),
                    res_id: parseInt(this.$route.params.id.split('_')[0]),
                    template_report: 'sdt_report_aladin.report_standard_po_menu'
                },
                {
                    headers: {
                    Authorization: `Bearer ${localStorage.getItem("token")}`
                    }
                }
                )
                .then((response) => {
                if (response.data.msg_status === "0002"){
                    this.$notify({
                        type: 'warn',
                        title: 'Expired',
                        text: 'Session expired, please sign in again.',
                    });
                    this.$router.replace('/signin')
                    return false
                } else if (response.data.response_code === "0000") {
                    const linkSource = `data:application/pdf;base64,${response.data.data.file}`;
                    const downloadLink = document.createElement("a");
                    const fileName = this.po.name + ".pdf";
                    downloadLink.href = linkSource;
                    downloadLink.download = fileName;
                    downloadLink.click();
                } else {
                    if (response.data.response_code !== "4000"){
                    this.$notify({
                        type: 'warn',
                        title: 'Warning',
                        text: response.data.message,
                    });
                    }
                }
                this.loading = false
                })
                .catch((e) => {
                this.loading = false;
                this.$notify({
                    type: 'error',
                    title: 'Something went wrong!',
                    text: e.response.data.message || e,
                    });
                });
        }
    },
    mounted () {
        this.getPODetail()
        this.getPOLines()
    }
}
</script>

<style>

</style>